
export const list = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/index.json?no=` + values
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)
    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}


export const moneylist = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/monies.json?no=` + values
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)
    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(money1 => ({ money1 }))
        .catch(errormoney1 => ({ errormoney1 }));


}


export const moneylist2 = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/monies2.json?no=` + values
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)
    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(money2 => ({ money2 }))
        .catch(errormoney2 => ({ errormoney2 }));


}



export const moneylist3 = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/monies3.json?no=` + values
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)
    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(money3 => ({ money3 }))
        .catch(errormoney3 => ({ errormoney3 }));


}

export const prelist = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/pre.json?no=` + values

    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)
    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payloadpre => ({ payloadpre }))
        .catch(errorpre => ({ errorpre }));


}



export const pre2list = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/pre2.json?no=` + values

    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)
    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payloadpre2 => ({ payloadpre2 }))
        .catch(errorpre2 => ({ errorpre2 }));


}



export const kaiyakulist = (values: any) => {
    //前月解約　で今月立ってるもの


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/kaiyakulist.json?no=` + values

    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)
    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(kaiyaku => ({ kaiyaku }))
        .catch(errorkaiyaku => ({ errorkaiyaku }));


}



export const startlist = (values: any) => {
    //前月解約　で今月立ってるもの


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/startlist.json?no=` + values

    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)
    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(start => ({ start }))
        .catch(errorstart => ({ errorstart }));


}



export const alllist = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/all.json`
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)

    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}

export const kozalist = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/koza.json`
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)

    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}




export const details = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    let url = `//192.168.0.202/fuelphp/public/money/rest/furilist/details.json?fkae_sqno=` + values.fkae_sqno + '&kys_no=' + values.kys_no + '&bk_no=' + values.bk_no + '&hy_no=' + values.hy_no
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
    // alert(url)

    return fetch(url, {
        method: 'get',

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}
// export const soymdlist = (values: any) => {


//     // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

//     // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
//     let url = `http://192.168.0.202/fuelphp/public/money/rest/solist/soymd.json`
//     // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
//     // alert(url)
//     return fetch(url, {
//         method: 'get',

//         // headers: { 'Content-type': 'application/json; charset=UTF-8' }
//         // body: JSON.stringify(values),
//         // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
//     })
//         .then(res => res.json())
//         .then(payload => ({ payload }))
//         .catch(error => ({ error }));


// }